import get from 'lodash.get';
import React, { useContext, useState } from 'react';
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';

import apiUtil from 'src/api/activation';
import CustomToast from 'src/components/CustomToast';
import { AppContext } from 'src/containers/Core/AppContext';
import { AppState } from 'src/containers/Core/AppReducer';
import { POS_ERROR, POS_SUCCESS, SOMETHING_WENT_WRONG } from 'src/containers/Core/Messages';
import { BUSINESS_ONBOARDING_STEP } from '..';

type POSModalProps = {
  onHide: VoidFunction;
  show: boolean;
  setOnboardingStep: (step: BUSINESS_ONBOARDING_STEP) => void;
  onConflict: (conflict: ConflictIdentifierResponse) => void;
};

const POSModal: React.FC<POSModalProps> = ({ show, onHide, setOnboardingStep, onConflict }) => {
  if (!show) {
    return null;
  }

  const [pos, setPos] = useState('');
  const [loading, setLoading] = useState(false);
  const { store } = useContext(AppContext);
  const { businessOnboardingDetails }: AppState = store;

  const businessUuid = get(businessOnboardingDetails, 'business.uuid');

  const posSubmit = async () => {
    try {
      if (!pos.trim().length) {
        setPos('');

        return;
      }
      setLoading(true);
      await apiUtil.setConfirmMapping(businessUuid, pos);
      toast(<CustomToast type="success" title="POS Information" description={POS_SUCCESS} />, { className: 'success' });
      onHide();
      setOnboardingStep(BUSINESS_ONBOARDING_STEP.ONBOARD_BUSINESS_COMMUNITY);
    } catch (error) {
      if (error.response.status === 409) {
        onConflict(error.response.data);
        onHide();
      } else {
        toast(<CustomToast title={SOMETHING_WENT_WRONG} description={POS_ERROR} />);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={true} onHide={onHide}>
      <Modal.Header className="font-size-16 font-weight-bold" closeButton>
        Enter POS Information
      </Modal.Header>
      <Modal.Body>
        <div>
          <p className=" mt-1">
            In order for us to automatically assign rewards to customers when they shop at your business, we need to
            know how your business apprears in credit card statements.
          </p>
          <p>Please enter your business's statement name EXACTLY as it is set up in yours POS.</p>
          <Form>
            <Row>
              <Col sm={12} md={6}>
                <Form.Group controlId="pos">
                  <Form.Label>POS Statement Name</Form.Label>
                  <Form.Control
                    value={pos}
                    type="text"
                    placeholder="Enter POS statement name"
                    // tslint:disable-next-line:no-any
                    onChange={(e: any) => {
                      setPos(e.target.value);
                    }}
                    autoComplete="off"
                    name="name"
                    maxLength={255}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal.Body>
      <Modal.Footer className="mx-3 mt-3 px-0">
        <Button disabled={loading} variant="outline-secondary" className="mx-2 px-4" onClick={onHide}>
          Cancel
        </Button>
        <Button className="px-4" disabled={!pos || loading} onClick={posSubmit}>
          {loading ? <Spinner animation="border" size="sm" variant="light" /> : 'Add'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default POSModal;
